import axios from 'axios'
import { Cookies } from 'quasar-framework'
import * as types from '../mutation-types'

// state
export const state = {
    userMenu: null,
}

// getters
export const getters = {
    userMenu: state => state.userMenu,
}

// mutations
export const mutations = {
    [types.SAVE_MENU] (state, {menu}) {
        state.userMenu = menu
    }
}

// actions
export const actions = {
    
    async saveMenu ({commit}) {
        try {
            this.portal_base = Cookies.get('portal')
            if (!Cookies.get('locale') || Cookies.get('locale') === undefined) {
                const d = new Date();
                d.setTime(d.getTime() + 86400000);
                document.cookie = "locale=pt; expires="+ d.toUTCString() + " ;path=/;SameSite=lax";
            }
            if (!Cookies.get('portal')) {
            await axios.get(`${config.PortalBase}/get-portal`)
                .then((response) => {
                    this.portal_base = response.data.id
                    const d = new Date();
                    d.setTime(d.getTime() + 86400000);
                    document.cookie = "portal="+this.portal_base+"; expires="+ d.toUTCString() + " ;path=/;SameSite=lax";
                })
            }
            const {data} = await axios.get(`${config.appUrl}/${this.portal_base}/${null}/menus?lang=pt`)
            commit(types.SAVE_MENU, {menu: data})
              
        } catch (e) {
            
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/userMenu.js